import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Role } from "@/types";
import { FormCreateRole } from "./form-create-role";
import { FormUpdateRole } from "./form-update-role";

type FormRolesProps = PropsWithChildren & {
  role?: Role;
};

export function FormRoles({ children, role }: FormRolesProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={role ? "Atualizar cargo" : "Novo cargo"}
      description={
        role
          ? "Preencha os campos para atualizar o cargo."
          : "Preencha os campos para criar um novo cargo."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      {role ? (
        <FormUpdateRole role={role} handleClose={() => setOpen(false)} />
      ) : (
        <FormCreateRole handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
